import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d83bbf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer" }
const _hoisted_2 = ["show"]
const _hoisted_3 = { class: "settings" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startNode" }, "Starting node", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "null"
}, null, -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "alphabetInput" }, "Alphabet: ", -1))
const _hoisted_10 = ["pattern"]
const _hoisted_11 = { class: "section" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "determinismCheckbox" }, "Determinstic Automa", -1))
const _hoisted_13 = { class: "section" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "animateCheckbox" }, "Animate Evaluation", -1))
const _hoisted_15 = { class: "section" }

import { ref, computed } from 'vue'
import Toggle from '@vueform/toggle'
import SquareButton from '@/components/SquareButton.vue'
import { parseList } from '@/assets/utilities'
import { csv } from '@/assets/predefined'
import { Nodes } from '@/assets/types'
import { reset } from '@/assets/memory'


export default /*#__PURE__*/_defineComponent({
  props: {
    alphabet: null,
    determinism: { type: Boolean },
    animated: { type: Boolean },
    start: null,
    nodes: null
  },
  emits: ["addNode", "remove", "addEdge", "validate", "update:animated", "update:alphabet", "update:determinism", "update:start", 'save', 'share', 'downloadSVG', 'findAMatch'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    alphabet: string[]
    determinism: boolean
    animated: boolean
    start: string

    nodes: Nodes
}





const show = ref(false)

const alphabetInput = ref(props.alphabet.join(','))
const alphabetModel = computed(() =>
    parseList(alphabetInput.value)
)
const determinismModel = ref(props.determinism)
const animatedModel = ref(props.animated)
const inputText = ref("")

function updateValue(variable: "animated" | "determinism" | "alphabet" | "start", value: any) {
    console.log(value)
    emits(`update:${variable}`, value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "popupMenu",
      show: show.value
    }, [
      _createVNode(SquareButton, {
        icon: "settings",
        active: show.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = show.value)),
        label: "Settings"
      }, null, 8, ["active"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("select", {
            name: "startNode",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (updateValue('start', $event.target!.value)))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(__props.nodes), (n) => {
              return (_openBlock(), _createElementBlock("option", {
                key: n,
                value: n
              }, _toDisplayString(__props.nodes[n].name), 9, _hoisted_7))
            }), 128))
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "alphabetInput",
            placeholder: "Alfabeto",
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_unref(csv).test($event.target?.value) && updateValue('alphabet', _unref(alphabetModel)))),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((alphabetInput).value = $event)),
            pattern: _unref(csv).source
          }, null, 40, _hoisted_10), [
            [_vModelText, alphabetInput.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_unref(Toggle), {
            id: "determinismCheckbox",
            class: "toggle",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (updateValue('determinism', determinismModel.value))),
            modelValue: determinismModel.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((determinismModel).value = $event)),
            "on-label": "on",
            "off-label": "off"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_unref(Toggle), {
            id: "animateCheckbox",
            class: "toggle",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (updateValue('animated', animatedModel.value))),
            modelValue: animatedModel.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((animatedModel).value = $event)),
            "on-label": "on",
            "off-label": "off"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(SquareButton, {
            icon: "share",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('share'))),
            label: "share"
          }),
          _createVNode(SquareButton, {
            icon: "image",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('downloadSVG'))),
            label: "download image"
          }),
          _createVNode(SquareButton, {
            icon: "sort_by_alpha",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('findAMatch'))),
            label: "find any random matching string"
          }),
          _createVNode(SquareButton, {
            icon: "clear",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(reset)())),
            label: "reset FSA"
          })
        ])
      ]),
      _createElementVNode("span", {
        class: "outside",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (show.value = false))
      })
    ], 8, _hoisted_2),
    _createVNode(SquareButton, {
      icon: "delete_forever",
      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('remove'))),
      label: "remove selected nodes and edges"
    }),
    _createVNode(SquareButton, {
      icon: "add_circle",
      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('addNode'))),
      label: "add new state"
    }),
    _createVNode(SquareButton, {
      icon: "commit",
      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('addEdge'))),
      label: "add new transition"
    }),
    _withDirectives(_createElementVNode("input", {
      id: "String",
      type: "text",
      placeholder: "Insert a string to validate",
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((inputText).value = $event)),
      onKeyup: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.$emit('validate', inputText.value)), ["enter"]))
    }, null, 544), [
      [_vModelText, inputText.value]
    ]),
    _createVNode(SquareButton, {
      icon: "skip_next",
      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('validate', inputText.value))),
      label: "evaluate string"
    })
  ]))
}
}

})